import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=6357c661&scoped=true&"
import script from "./chatRoom.vue?vue&type=script&lang=js&"
export * from "./chatRoom.vue?vue&type=script&lang=js&"
import style0 from "./chatRoom.vue?vue&type=style&index=0&id=6357c661&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357c661",
  null
  
)

export default component.exports